

export default {
  locale: 'ro',
  Pagination: {
    items_per_page: '/ pagină',
    jump_to: 'Mergi la',
    jump_to_confirm: 'confirm',
    page: '',
    prev_page: 'Pagina Anterioară',
    next_page: 'Pagina Următoare',
    prev_5: '5 Pagini Anterioare',
    next_5: '5 Pagini Următoare',
    prev_3: '3 Pagini Anterioare',
    next_3: '3 Pagini Următoare',
    page_size: 'Page Size'
  },
  DatePicker: {
    lang: {
      placeholder: 'Selectează data',
      rangePlaceholder: ['Data start', 'Data sfârșit'],
      locale: 'ro_RO',
      today: 'Azi',
      now: 'Acum',
      backToToday: 'Înapoi la azi',
      ok: 'Ok',
      clear: 'Șterge',
      month: 'Lună',
      year: 'An',
      timeSelect: 'selectează timpul',
      dateSelect: 'selectează data',
      weekSelect: 'Alege o săptămână',
      monthSelect: 'Alege o lună',
      yearSelect: 'Alege un an',
      decadeSelect: 'Alege un deceniu',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Luna anterioară (PageUp)',
      nextMonth: 'Luna următoare (PageDown)',
      previousYear: 'Anul anterior (Control + stânga)',
      nextYear: 'Anul următor (Control + dreapta)',
      previousDecade: 'Deceniul anterior',
      nextDecade: 'Deceniul următor',
      previousCentury: 'Secolul anterior',
      nextCentury: 'Secolul următor'
    },
    timePickerLocale: {
      placeholder: 'Selectează ora'
    }
  },
  TimePicker: {
    placeholder: 'Selectează ora'
  },
  Calendar: {
    lang: {
      placeholder: 'Selectează data',
      rangePlaceholder: ['Data start', 'Data sfârșit'],
      locale: 'ro_RO',
      today: 'Azi',
      now: 'Acum',
      backToToday: 'Înapoi la azi',
      ok: 'Ok',
      clear: 'Șterge',
      month: 'Lună',
      year: 'An',
      timeSelect: 'selectează timpul',
      dateSelect: 'selectează data',
      weekSelect: 'Alege o săptămână',
      monthSelect: 'Alege o lună',
      yearSelect: 'Alege un an',
      decadeSelect: 'Alege un deceniu',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Luna anterioară (PageUp)',
      nextMonth: 'Luna următoare (PageDown)',
      previousYear: 'Anul anterior (Control + stânga)',
      nextYear: 'Anul următor (Control + dreapta)',
      previousDecade: 'Deceniul anterior',
      nextDecade: 'Deceniul următor',
      previousCentury: 'Secolul anterior',
      nextCentury: 'Secolul următor'
    },
    timePickerLocale: {
      placeholder: 'Selectează ora'
    }
  },
  global: {
    placeholder: 'Selectează'
  },
  Table: {
    filterTitle: 'Filtrează',
    filterConfirm: 'OK',
    filterReset: 'Resetează',
    selectAll: 'Selectează pagina curentă',
    selectInvert: 'Inversează pagina curentă',
    sortTitle: 'Ordonează',
    expand: 'Extinde rândul',
    collapse: 'Micșorează rândul',
    filterEmptyText: 'Fără filtre',
    emptyText: 'Nu există date',
    selectNone: 'Șterge selecția',
    selectionAll: 'Selectează toate datele',
    triggerDesc: 'Apasă pentru ordonare descrescătoare',
    triggerAsc: 'Apasă pentru ordonare crescătoare',
    cancelSort: 'Apasă pentru a anula ordonarea'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Anulare',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Anulare'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Căutare',
    itemUnit: 'element',
    itemsUnit: 'elemente',
    remove: 'Șterge',
    selectCurrent: 'Selectează pagina curentă',
    removeCurrent: 'Șterge pagina curentă',
    selectAll: 'Selectează toate datele',
    removeAll: 'Șterge toate datele',
    selectInvert: 'Inversează pagina curentă'
  },
  Upload: {
    uploading: 'Se transferă...',
    removeFile: 'Înlătură fișierul',
    uploadError: 'Eroare la upload',
    previewFile: 'Previzualizare fișier',
    downloadFile: 'Descărcare fișier'
  },
  Empty: {
    description: 'Fără date'
  },
  Icon: {
    icon: 'icon'
  },
  Text: {
    edit: 'editează',
    copy: 'copiază',
    copied: 'copiat',
    expand: 'extinde'
  },
  PageHeader: {
    back: 'înapoi'
  },
  Image: {
    preview: 'Preview'
  }
};
